export default {
	entryPage: {
		/** The frame's accessible name: a frame with no title is announced as nothing. */
		frameTitle: "Start page of {dataspace}",
		/** The small button over the page, for those who may read processes. */
		openProcesses: "Processes",
		loading: "Loading the start page…",
		loadFailed: "The start page could not be loaded.",
		// The page called window.notitia.startProcess(name) and it could not be done.
		startUnavailable: "No process called “{name}” can be started here.",
		startForbidden: "You may not start processes in this dataspace.",
		startNeedsClick: "Starting a process needs a click on the page.",
		startBusy: "A process is already being started; try again in a moment.",
		startFailed: "The process could not be started.",
		// …it was started and did not come up.
		startNotReady: "“{name}” was started but did not come up: {reason}",
		// The reasons it gives when the server named none.
		startNotReadyTimeout: "it did not say it was ready in time",
		startNotReadyStatus: "its status is “{status}”",
		// The page called window.notitia.sendEvent and it could not be done. Told to the page only.
		eventForbidden: "You may not send events to processes in this dataspace.",
		eventBusy: "Too many events at once; try again in a moment.",
		eventUnknownProcess: "There is no process called “{name}” here.",
		eventFailed: "The event could not be sent.",
	},
};
